import { buildQuery, IFilter, IPage } from "@/api/api.ts";
import { API_URL } from "@/config/constants.ts";
import axios from "axios";
import { UserType } from "./profile.ts";
import { IStore } from "./store.ts";
import { ICreateUser } from "./auth.ts";

const API = `${API_URL}/users`;

export interface IStoreUser extends UserType {
    stores: IStore[];
    is_superuser: boolean;
}

export interface IUpdateUser extends ICreateUser {}

export const getAllUsers = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter
) => {
    const result = await axios.get<IPage<IStoreUser>>(
        `${API}?page=${page}&size=${size}&${buildQuery(filter)}`,
        {
            headers: {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                Pragma: "no-cache",
                Expires: "0",
            },
        }
    );
    return result.data;
};

export const getSingleUser = async (user_id: string) => {
    const result: { data: IStoreUser } = await axios.get(`${API}/${user_id}`);
    return result.data;
};

export const updateUser = async (user_id: number, data: IUpdateUser) => {
    const result: { data: IStoreUser } = await axios.put(
        `${API}/${user_id}`,
        data
    );
    return result.data;
};

export const deleteUser = async (user_id: number) => {
    const result: { data: IStoreUser } = await axios.delete(
        `${API}/${user_id}`
    );
    return result.data;
};

export const sendReminderEmail = async (user_id: number) => {
    const result: { data: IStoreUser } = await axios.post(
        `${API}/remind/${user_id}`
    );
    return result.data;
};
